import {ChangeDetectionStrategy, Component} from '@angular/core';
import {ContentService} from "../../_services/content.service";
import {SnackbarService} from "../../_services/snackbar.service";
import {ContentLibraryCategory, HelpfulLink} from "../../_types/content";

@Component({
    selector: 'app-resources',
    templateUrl: './resources.component.html',
    styleUrl: './resources.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ResourcesComponent {
    helpfulLinks: HelpfulLink[] = [];
    resources: ContentLibraryCategory[] = [];
    loading: boolean = true;
    loadFailed: boolean = false;
    private pendingRequests: number = 2;

    constructor(private contentService: ContentService,
                private snackbarService: SnackbarService) {
        this.contentService.libraryCategories().subscribe({
            next: r => {
                this.resources = r;
                this.finishLoading();
            }, error: error => {
                console.error(error)
                this.loadFailed = true;
                this.finishLoading();
                this.snackbarService.openSnackBar('Sorry, we could not load resources. Please try again later.', 'error')
            }
        });

        this.contentService.helpfulLinks().subscribe({
            next: r => {
                this.helpfulLinks = r;
                this.finishLoading();
            }, error: error => {
                console.error(error)
                this.loadFailed = true;
                this.finishLoading();
                this.snackbarService.openSnackBar('Sorry, we could not load helpful links. Please try again later.', 'error')
            }
        });
    }

    private finishLoading(): void {
        this.pendingRequests--;
        this.loading = this.pendingRequests > 0;
    }

    link(url: string, download: boolean, name?: string): void {
        if (download) {
            let downloadName: string = url
            if (name) {
                downloadName = name?.replace(/ /g, "_");
            }
            fetch(url)
                // check to make sure you didn't have an unexpected failure (may need to check other things here depending on use case / backend)
                .then(resp => resp.status === 200 ? resp.blob() : Promise.reject('something went wrong'))
                .then(blob => {
                    const url: string = window.URL.createObjectURL(blob);
                    const a: HTMLAnchorElement = document.createElement('a');
                    a.style.display = 'none';
                    a.href = url;
                    // the filename you want
                    a.download = downloadName;
                    document.body.appendChild(a);
                    a.click();
                    window.URL.revokeObjectURL(url);
                })
                .catch((): void => {
                    console.error('catch error')
                    window.open(url, '_blank')?.focus();
                });
        } else {
            window.open(url, '_blank')?.focus();
        }
    }

}
